import firebase from 'firebase';

var firebaseConfig = {
  apiKey: "AIzaSyAXqNvAcfQwKjinA-dtTHfC6WiTnxxEDt8",
  authDomain: "mindful-phalanx-283010.firebaseapp.com",
  databaseURL: "https://mindful-phalanx-283010.firebaseio.com",
  projectId: "mindful-phalanx-283010",
  storageBucket: "mindful-phalanx-283010.appspot.com",
  messagingSenderId: "995529536825",
  appId: "1:995529536825:web:4020e085d5f9b3ddd224e8",
  measurementId: "G-ZJW51V0YYB"
};

var fire = firebase.initializeApp(firebaseConfig);

export default fire;